import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetAccessManagementPermissions,
	GetAccessManagementPermissionsParams,
	GetAccessManagementPermissionsResponse,
} from 'domain/usecases';

export class RemoteGetAccessManagementPermissions implements GetAccessManagementPermissions {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetAccessManagementPermissionsResponse>,
	) {}

	async get({
		signal,
		...restParams
	}: GetAccessManagementPermissionsParams): Promise<GetAccessManagementPermissionsResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: restParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return {compartilheAcessoSeuPlano: []};
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
